import lodash from 'lodash'
import { useMemo } from 'react'
import { Create, Edit, SimpleForm } from 'react-admin'
import { useCurrentStructType } from './hooks/useCurrentStructType'
import { StructFormContent } from './StructFormContent'
import { StructsBreadcrumbs } from './StructsBreadcrumbs'
import { AdStructTypes } from './types'

// ensure during struct creation that this field is set since final form does not set fields that are not yet dirty
const formatSubmitValues = (values) => {
  const isAdStructType = AdStructTypes.includes(values.type)

  if (isAdStructType) {
    const completedValue = lodash.get(values, 'data.top_level_fields.is_completed', false)

    const formattedValues = lodash.cloneDeep(values)
    if (!formattedValues.data) {
      formattedValues.data = {}
    }
    if (!formattedValues.data.top_level_fields) {
      formattedValues.data.top_level_fields = {}
    }

    formattedValues.data.top_level_fields.is_completed = completedValue

    return formattedValues
  }

  return values
}

export const StructCreate = (props) => {
  const { currentTypeId, currentType } = useCurrentStructType(props.match.params.structType)
  const realRecord = useMemo(() => ({ type: currentTypeId, data: {} }), [currentTypeId])

  const redirectTo = currentType?.singular ? '/structs/singular' : `/structs/${currentTypeId}`

  return (
    <Create
      record={realRecord}
      {...props}
      breadCrumbs={<StructsBreadcrumbs currentType={currentType} mode="create" />}
      basePath={`/structs/${currentTypeId}`}
      redirect={() => redirectTo}
    >
      <SimpleForm formatSubmitValues={formatSubmitValues}>
        <StructFormContent isCreate={true} />
      </SimpleForm>
    </Create>
  )
}

export const StructEdit = (props) => {
  const { currentTypeId, currentType } = useCurrentStructType(props.record?.type || props.match.params.structType)

  const redirectTo = currentType?.singular ? '/structs/singular' : `/structs/${currentTypeId}`

  return (
    <Edit
      {...props}
      filter={{ include_version_history: true }}
      breadCrumbs={<StructsBreadcrumbs currentType={currentType} mode="edit" />}
      basePath={`/structs/${currentTypeId}`}
      redirect={() => redirectTo}
    >
      <SimpleForm formatSubmitValues={formatSubmitValues}>
        <StructFormContent isCreate={false} />
      </SimpleForm>
    </Edit>
  )
}
